var map = {
	"./button/index.vue": 636,
	"./divider/index.vue": 640
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 635;


//////////////////
// WEBPACK FOOTER
// ./src/components-mall \.vue$
// module id = 635
// module chunks = 24